import { Component, OnInit } from '@angular/core';
import { Stream } from 'src/models/stream';
import { InfiniteScrollableComponent } from '../../base/infinite-scrollable/infinite-scrollable.component';
import { StreamService } from 'src/app/services/stream.service';
import { PlayerService } from 'src/app/services/player.service';

@Component({
  selector: 'app-top-stations',
  templateUrl: './top-stations.component.html',
  styleUrls: ['./top-stations.component.scss']
})
export class TopStationsComponent extends InfiniteScrollableComponent implements OnInit {

  public streams = new Array<Stream>();

  private itemsPerPage = 42;

  public topStations = new Array<Stream>();

  public scrollControlEnabled = false;

  constructor(
    private streamService: StreamService,
    private playerService: PlayerService) {
    super();
  }

  ngOnInit() {
    this.streams = new Array<Stream>();
    this.start = 0;

    this.loadStreams();
  }

  protected getItemsPerPage(): number {
    return this.itemsPerPage;
  }

  protected loadStreams() {
    this.scrollControlEnabled = false;

    this.streamService.getTopStations(this.start, this.itemsPerPage).subscribe((value: Stream[]) => {
      value.forEach((stream: Stream) => this.streams.push(stream));

      if (value.length === this.itemsPerPage) {
        this.scrollControlEnabled = true;
      }
    });
  }

  public onPlayStreamClicked(stream: Stream) {
    this.playerService.setCurrentStream(stream);
  }

}
